import { render, staticRenderFns } from "./DetailsStudentEmpower.vue?vue&type=template&id=550f1ec4&scoped=true&"
import script from "./DetailsStudentEmpower.vue?vue&type=script&lang=js&"
export * from "./DetailsStudentEmpower.vue?vue&type=script&lang=js&"
import style0 from "./DetailsStudentEmpower.vue?vue&type=style&index=0&id=550f1ec4&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550f1ec4",
  null
  
)

export default component.exports